export default __webpack_public_path__ + "static/media/undraw_in_sync_re_jlqd.a8085ca2.svg";